export default "__VITE_ASSET__CxUN7YnF__"